import React from "react";
import styled from "styled-components";
import { message, Form } from "antd";

import colors from "constants/palette";
import Search from "components/inputs/Search";
import Fetch from "components/Fetch";
import Loading from "components/App/Loading";
import { Header } from "components/App/styled";
import DeleteButton from "components/buttons/DeleteButton";
import BackBtn from "components/buttons/BackBtn";
import { StyledModal } from "components/App/styled";
import { List, ListRow } from "components/Tables/List";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
import NumberInput from "components/inputs/NumberInput";
import Select from "components/inputs/Select";

export default function Shop({ returnPage }) {
  const [initialData, setInitialData] = React.useState(null);
  const [reload, setReload] = React.useState(false);
  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    Fetch.get("/shop", (res) => {
      setInitialData(res[0]);
    });
    setReload(false);
  }, [reload]);

  const onSubmit = (data) => {
    const submitData = { ...data, data: JSON.stringify({}) };
    setLoading(true);

    // update :::::::::
    Fetch.put("/shop", submitData, (res) => {
      if (res?.success) {
        message.success("با موفقیت آپدیت شد");
        setInitialData(null);
        setReload(true);
      } else {
        if (res?.errors?.title) {
          message.error(res?.errors.title[0]);
        } else {
          message.error("خطایی رخ داده است");
        }
      }
    });
    setLoading(false);
  };

  if (!initialData) {
    return <Loading />;
  }
  if (initialData) {
    form.setFieldsValue(initialData);
  }
  return (
    <Container>
      <HeaderContainer>
        <Header>تنظیمات فروشگاه</Header>
        <BackBtn onClick={returnPage} />
      </HeaderContainer>
      <Form
        form={form}
        layout="vertical"
        style={{ direction: "rtl" }}
        name={initialData ? "update" : "new"}
        onFinish={onSubmit}
      >
        <Label>توضیح کوتاه :</Label>
        <Form.Item
          name="description"
          rules={[
            {
              required: true,
              message: "لطفا توضیح را وارد کنید!",
            },
          ]}
        >
          <Input size="large" placeholder="" />
        </Form.Item>
        <Label>تلفن :</Label>
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              message: "لطفا تلفن فروشگاه را وارد کنید!",
            },
          ]}
        >
          <Input size="large" placeholder="" />
        </Form.Item>

        <Label>آدرس :</Label>
        <Form.Item
          name="address"
          rules={[
            {
              required: true,
              message: "لطفا آدرس را وارد کنید!",
            },
          ]}
        >
          <Input size="large" placeholder="" />
        </Form.Item>
        <Label>لینک اینستاگرام :</Label>
        <Form.Item
          name="instagram"
          rules={[
            {
              required: true,
              message: "لطفا لینک اینستاگرام را وارد کنید!",
            },
          ]}
        >
          <Input size="large" placeholder="" />
        </Form.Item>

        <Button
          loading={loading}
          htmlType="submit"
          style={{ width: "100%", marginTop: 16 }}
        >
          اعمال تغییرات
        </Button>
      </Form>
    </Container>
  );
}
const Container = styled.div`
  padding: 26px 20px;

  @media (max-width: 1280px) {
    min-height: calc(100vh - 210px);
  }
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
